import {
  IPayoutSettingsResponse,
  PayoutDestinationType
} from "@wingspanhq/payments/dist/interfaces";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorDefaultDestination } from "../../../shared/selectors/selectorDefaultDestination";

export const selectorIsPlatformBalanceAccount = (
  internalAccount: bankingApiSpec.InternalAccount,
  payoutSettings?: IPayoutSettingsResponse
) => {
  if (!payoutSettings) {
    return false;
  }

  const defaultDestination = selectorDefaultDestination(payoutSettings);
  if (
    defaultDestination?.destinationType !==
    ("InternalAccount" as PayoutDestinationType)
  ) {
    return false;
  }
  return (
    internalAccount.internalAccountId === defaultDestination?.destinationId
  );
};
